import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import { Toast, Lazyload, Form, Cell, CellGroup, Field, Icon, Button, RadioGroup, Radio, Popup, Area, Step, Steps, Loading, ActionSheet, Overlay, Dialog, Picker, Skeleton, CountDown } from 'vant';
import 'normalize.css/normalize.css';
import '@/utils/bridge-package.js'
import AppMixin from "./mixins/AppAllMethods";
import './directives/index'
import fullMask from './directive/fullMask';
Vue.directive('fullMask', fullMask);
import 'swiper/swiper-bundle.min.css'


Vue.use(Toast)
    .use(Lazyload)
    .use(Popup)
    .use(Area)
    .use(Form)
    .use(Cell)
    .use(CellGroup)
    .use(Field)
    .use(Icon)
    .use(Button)
    .use(RadioGroup)
    .use(Radio)
    .use(Overlay)
    .use(Loading)
    .use(Step)
    .use(Steps)
    .use(ActionSheet)
    .use(Dialog)
    .use(Picker)
    .use(CountDown)

/**
 * app相关公共bridge 统一混入
 */
Vue.mixin(AppMixin);

if (process.env.VUE_APP_IS_DEBUG === 'true') {
    import ('vconsole').then(VConsole => {
        new VConsole.default();
    });
}

/**
 * 消息提示的环境配置
 */

Vue.config.productionTip = false;


/**
 * app Bridge注册相关
 */

import { eventBridgeInit, webLoadFinish, handleUserInfo, getCommonStatus, handleDeviceInfo} from './utils/webridge';
const { isApp } = store.getters.platform;
if (isApp) {

    window._native_ios_finish = false;
    window._native_response_finish = false;

    // 注册事件分发
    eventBridgeInit();

    // 注册检查网页是否活跃事件
    webLoadFinish();

    // ios检查
    window._ios_or_response_finish = type => {
        console.log('type', type);
        console.log('ios', window._native_ios_finish);
        console.log('接口', window._native_response_finish);
        if (window._native_ios_finish && window._native_response_finish) {
            webridge.jsToNative({
                handler: 'CommonUI',
                action: 'loadingControl',
                params: { loading: false, error: false }
            });
        }
    };
    // 初始化用户信息 并生成vue实例
    handleUserInfo(render);

    handleDeviceInfo()

    window._native_ios_finish_func = () => {
        window._native_ios_finish = true;
        window._ios_or_response_finish('ios');
    };
} else {
    render();
}


/**
 * 生成vue实例
 */

function render() {
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
}
